import { Pipe, PipeTransform } from '@angular/core';
import { MaskPipe } from 'ngx-mask';

import { PhoneValidatorService } from '@main-application/shared/services/phone-validator.service';

@Pipe({
  name: 'phoneNumber',
})
export class PhoneNumberPipe implements PipeTransform {
  constructor(private mask: MaskPipe, private phoneValidatorService: PhoneValidatorService) {}

  transform(value: string): string {
    const initValue = value?.length ? value : '';
    const { phoneNumber, phoneCode } = this.phoneValidatorService.parsePhoneNumber(value, false);
    const { maskPattern, validPhoneNumberLength } = this.phoneValidatorService.onGetMaskPattern(phoneCode);

    const masked = phoneNumber ? this.mask.transform(phoneNumber, maskPattern) : '';

    const extra =
      phoneNumber && phoneNumber.length > validPhoneNumberLength ? phoneNumber.slice(validPhoneNumberLength) : '';
    return phoneCode ? `+${phoneCode} ${masked}${extra}` : phoneNumber || initValue;
  }
}
